import React from 'react';
import Loader from '../../Loader/Loader';
import styles from './RoutePending.module.scss';

const RoutePending = () => (
    <div className={styles.pendingShell}>
        <div className={styles.pendingContent}>
            <Loader />
            <p>Loading page...</p>
        </div>
    </div>
);

export default RoutePending;
